module.exports = __webpack_public_path__ + "img/arrow-circle-down.c7e43a2f.svg";